export const VIDEO_KEY = 'video'
export const IMAGE_KEY = 'image'

export const MAX_CROP_VIEW_WIDTH_SIZE = 820
export const MAX_CROP_VIEW_HEIGHT_SIZE = 410
